import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyCell } from '../../formatters/genericFormatters';
import { AssetApprovalStatus } from '@casops/store/apis/assetApprovalsApi';

const approvalStatusColorMap: Record<AssetApprovalStatus, BadgeStatus> = {
  [AssetApprovalStatus.PreApproved]: BadgeStatus.Healthy,
  [AssetApprovalStatus.ApprovalRequired]: BadgeStatus.Caution,
  [AssetApprovalStatus.PreApprovedInvalid]: BadgeStatus.Danger,
  [AssetApprovalStatus.Conflict]: BadgeStatus.Danger,
};

interface ApprovalStatusCellRendererProps {
  value?: AssetApprovalStatus;
}

export default function ApprovalStatusCellRenderer({
  value,
}: ApprovalStatusCellRendererProps): ReactElement | string {
  const { t } = useTranslation();

  return value ? (
    <StatusCell label={t(`AssetApprovalStatus.${value}`)} status={approvalStatusColorMap[value]} />
  ) : (
    EmptyCell
  );
}
